import MonitoramentoActionTypes from "./action-types.ts";

export const monitoramentoState = (payload) => ({
    type: MonitoramentoActionTypes.MONITORAMENTO,
    payload,
});